{
  "emailConfig": {
    "title": "E-mail Configuratie",
    "subtitle": "Configureer je e-mailclient met Siteoplossing mail instellingen",
    "emailInput": {
      "title": "Je E-mailadres",
      "label": "E-mailadres",
      "placeholder": "jouw-email{'@'}domein.com",
      "description": "Voer je e-mailadres in om configuratiebestanden en instellingen te genereren."
    },
    "automatic": {
      "title": "Automatische Configuratie",
      "description": "Klik om je e-mailclient te starten en configureren:",
      "iosMail": "iOS Mail"
    },
    "manual": {
      "title": "Handmatige Configuratie",
      "description": "Gebruik deze instellingen om je e-mailclient handmatig te configureren:",
      "incoming": {
        "title": "Inkomende E-mail (IMAP)",
        "server": "Server",
        "port": "Poort",
        "security": "Beveiliging",
        "username": "Gebruikersnaam"
      },
      "outgoing": {
        "title": "Uitgaande E-mail (SMTP)",
        "server": "Server",
        "port": "Poort",
        "security": "Beveiliging",
        "auth": "Authenticatie",
        "authRequired": "Vereist"
      },
      "copy": "Kopieer Configuratie"
    },
    "instructions": {
      "title": "Setup Instructies",
      "step1": "Voer je e-mailadres hierboven in om de configuratie te personaliseren.",
      "step2": "Voor automatische setup, klik op je e-mailclient om het configuratiebestand te downloaden.",
      "step3": "Voor handmatige setup, kopieer de serverinstellingen en voer ze in bij je e-mailclient.",
      "step4": "Neem contact op met ondersteuning als je hulp nodig hebt bij het configuratieproces."
    },
    "tutorial": {
      "back": "← Terug naar e-mail instellingen",
      "progress": "Stap {current} van {total}",
      "accountLabel": "Account:",
      "stepImageAlt": "Stap {step}: {title}",
      "successTitle": "E-mail succesvol ingesteld!",
      "helpDivider": "Lukt het niet zelf?",
      "remoteTitle": "Remote installatie — 20 minuten",
      "remoteDescription": "We zetten je e-mail samen met jou op via een schermdeelsessie. Gegarandeerd werkend.",
      "remoteCta": "📅 Plan een sessie in",
      "remoteNote": "Geen technische kennis nodig"
    },
    "iosTutorial": {
      "badge": "🍎 iOS Mail instellen",
      "title": "iOS Mail instellen via webmail",
      "subtitle": "Volg deze {steps} stappen om je e-mail automatisch in te stellen op je iPhone. Duurt minder dan 3 minuten.",
      "step7OpensSettings": "Opent automatisch in Instellingen",
      "step7EnterEmail": "← Ga terug om je e-mailadres in te voeren",
      "successDescription": "Open de Mail-app op je iPhone. Je berichten worden nu geladen.",
      "steps": {
        "1": {
          "title": "Ga naar webmail",
          "description": "Open Safari op je iPhone en ga naar {webmailHost}"
        },
        "2": {
          "title": "Log in",
          "description": "Vul je volledige e-mailadres en wachtwoord in"
        },
        "3": {
          "title": "Tik op 'Automatically configure my device'",
          "description": "Dan gaan we naar het volgende scherm"
        },
        "4": {
          "title": "Kies IMAP over SSL/TLS",
          "description": "Selecteer 'IMAP over SSL/TLS' in de rij van 'iOS for Iphone/iPad/Ipod'"
        },
        "5": {
          "title": "Tik op Proceed",
          "description": "Bevestig je keuze door op Proceed te tikken"
        },
        "6": {
          "title": "Accepteer de melding",
          "description": "Accepteer de beveiligingsmelding van je browser"
        },
        "7": {
          "title": "Profiel gedownload",
          "description": "Het configuratieprofiel staat klaar op je iPhone. Ga nu naar Instellingen."
        },
        "8": {
          "title": "Open Instellingen",
          "description": "Ga terug naar je homescreen en open de app Instellingen"
        },
        "9": {
          "title": "Tik op 'Profile Downloaded'",
          "description": "Je ziet bovenaan een melding. Tik op Profile Downloaded."
        },
        "10": {
          "title": "Open het profiel",
          "description": "Open de installatiepagina van het configuratieprofiel"
        },
        "11": {
          "title": "Tik op Install",
          "description": "Tik rechts bovenin op Install en bevestig nogmaals met Install"
        },
        "12": {
          "title": "Voer je toegangscode in",
          "description": "Vul je iPhone-toegangscode in om door te gaan"
        },
        "13": {
          "title": "Voer je e-mailwachtwoord in",
          "description": "Vul het wachtwoord van je e-mailaccount in"
        },
        "14": {
          "title": "Je e-mail is succesvol ingesteld",
          "description": "Het configuratieprofiel is nu actief op je iPhone."
        },
        "15": {
          "title": "Open de Mail-app om te beginnen",
          "description": "Je inbox zal nu alle berichten tonen. Je e-mail werkt perfect!"
        }
      }
    },
    "gmailTutorial": {
      "badge": "📧 Gmail instellen",
      "title": "Gmail instellen op je computer",
      "subtitle": "Volg deze {steps} stappen om je e-mail automatisch via IMAP in te stellen in Gmail. Duurt minder dan 5 minuten.",
      "successDescription": "Open je Gmail-account in je browser of e-mailclient. Je berichten worden nu automatisch gesynchroniseerd.",
      "steps": {
        "1": {
          "title": "Open Gmail",
          "description": "Open de Gmail app op je computer of ga naar gmail.com"
        },
        "2": {
          "title": "Voer je e-mailadres in",
          "description": "Voer je volledige e-mailadres in en klik op Volgende"
        },
        "3": {
          "title": "Kies accounttype",
          "description": "Kies 'Persoonlijk (IMAP)' als accounttype"
        },
        "4": {
          "title": "Voer je wachtwoord in",
          "description": "Vul je wachtwoord in en klik op Volgende"
        },
        "5": {
          "title": "Inkomende server configureren",
          "description": "Zorg dat de server '{mailServer}' vermeldt en klik op Volgende"
        },
        "6": {
          "title": "Verificatie van instellingen",
          "description": "Je instellingen worden geverifieerd. Als dit slaagt zijn de instellingen correct geconfigureerd."
        },
        "7": {
          "title": "Uitgaande server configureren",
          "description": "Zorg dat de SMTP-server '{mailServer}' vermeldt en klik op Volgende"
        },
        "8": {
          "title": "Standaardconfiguratie",
          "description": "De standaardconfiguratie kan behouden worden. Klik op Volgende om door te gaan"
        },
        "9": {
          "title": "Account afmaken",
          "description": "Wijzig je accountnaam, stel je weergavenaam in en klik op Volgende. Klaar!"
        }
      }
    }
  },
  "checkout": {
    "headingId": "checkout-heading",
    "heading": "Klant & Betaal Details",
    "finalize": "Afronden & Afrekenen",
    "section": {
      "customerPaymentDetails": "Klant & Betaal Details"
    },
    "form": {
      "firstnameLabel": "Voornaam",
      "lastnameLabel": "Achternaam",
      "addressLabel": "Straat & Huisnummer",
      "postalCodeLabel": "Postcode",
      "cityLabel": "Stad",
      "countryLabel": "Land",
      "selectCountryOption": "Selecteer een land",
      "companyLabel": "Bedrijfsnaam",
      "kvkLabel": "KvK Nummer",
      "vatLabel": "BTW Nummer",
      "optional": "optioneel",
      "legalAgreementPrefix": "Ik ga akkoord met de",
      "termsLink": "Algemene Voorwaarden",
      "legalAgreementMiddle": "en heb de",
      "privacyLink": "Privacy Policy",
      "processing": "Verwerken…",
      "processingCountdown": "({count})",
      "payNow": "Nu Betalen"
    },
    "blocking": {
      "emailRequired": "E-mail is verplicht.",
      "completeStep1": "Voltooi eerst stap 1."
    },
    "payment": {
      "longProcessingError": "Betaling duurt te lang. Probeer opnieuw.",
      "startError": "Er ging iets mis bij het starten van de betaling."
    },
    "steps": {
      "step1": {
        "label": "Account aanmaken"
      },
      "step2": {
        "label": "Klantgegevens"
      },
      "step3": {
        "label": "Betaling"
      }
    },
    "validation": {
      "firstnameRequired": "Voornaam is verplicht",
      "lastnameRequired": "Achternaam is verplicht",
      "addressRequired": "Straat + huisnummer is verplicht",
      "postalCodeRequired": "Postcode is verplicht",
      "cityRequired": "Stad is verplicht",
      "countryRequired": "Land is verplicht",
      "tosAgreementRequired": "Je moet akkoord gaan met de voorwaarden"
    }
  },
  "domain": {
    "subtitle": "Jouw website's unieke adres op internet - kies iets catchy zodat klanten je gemakkelijk kunnen vinden en onthouden.",
    "placeholder": "bijv. jouwbedrijf.nl",
    "check": "Controleren",
    "restart": "Probeer ander domein",
    "optionalNote": "Niet zeker welk domein het beste past? Geen zorgen. Je kunt dit leeg laten - ik help je beslissen",
    "askOwnership": {
      "title": "Is dit jouw domein?",
      "yes": "Ja",
      "no": "Nee"
    },
    "transfer": {
      "title": "Wil je je domein naar ons overzetten?",
      "subtitle": "Ik beheer DNS, email en verlengingen voor je.",
      "transfer": "Ja, Overzetten",
      "keep": "Houden bij mijn registrar"
    },
    "notOwned": {
      "title": "Wat wil je als volgende doen?",
      "subtitle": "Dit domein is al bezet en niet van jou.",
      "tryAnother": "Probeer Ander Domein",
      "skip": "Doorgaan Zonder Domein"
    },
    "finalStates": {
      "available": {
        "title": "Perfect! Je domein is beschikbaar",
        "subtitle": "{domain} wordt voor je geregistreerd",
        "included1": "1-jaar .nl/.com registratie inbegrepen",
        "included2": "Gratis SSL certificaat & beveiliging",
        "included3": "Beheerde DNS & email setup",
        "price": "€15/jaar • Geregistreerd bij checkout"
      },
      "transfer": {
        "title": "Domein overzetting geregeld",
        "subtitle": "{domain} wordt overgebracht naar jouw beheer",
        "included1": "Volledige domein overzetting & beheer",
        "included2": "DNS configuratie & email setup",
        "included3": "SSL certificaat & beveiligingsmonitoring",
        "timeline": "Overzetting duurt 1 dag"
      },
      "keep": {
        "title": "Je bestaande domein gebruiken",
        "subtitle": "{domain} blijft bij je huidige provider",
        "included1": "DNS configuratie instructies verstrekt",
        "included2": "SSL setup begeleiding inbegrepen",
        "included3": "Technische ondersteuning voor verbinding",
        "cost": "Geen extra kosten • Jij beheert verlengingen"
      },
      "deferred": {
        "title": "Domein selectie overgeslagen",
        "subtitle": "Je kunt later nog een domein toevoegen indien nodig",
        "included1": "Website werkt zonder custom domein",
        "included2": "Voeg domein toe wanneer je wilt na lancering",
        "included3": "Volledige setup ondersteuning wanneer je klaar bent",
        "cost": "Geen extra kosten nu"
      },
      "consultation": {
        "title": "Domein consult ingepland",
        "subtitle": "We kiezen samen het perfecte domein",
        "included1": "Domein brainstorm sessie",
        "included2": "Marktonderzoek & aanbevelingen",
        "included3": "Registratie voor je geregeld",
        "cost": "Consult inbegrepen • Domein tegen kostprijs"
      }
    },
    "footer": ".nl en .com domeinen slechts €15/jaar • Gratis SSL inbegrepen • Beheerde DNS"
  },
  "customPackage": {
    "mentalHeadline": "Nog maar 3 snelle stappen om je pakket te selecteren",
    "mentalSubline": "Selecteer welke pakketten je wilt, koppel je domein of laat het leeg, en review voor checkout. Duurt minder dan 2 minuten.",
    "limitedLabel": "Beperkte Tijd:",
    "limitedOffer": "21% BTW weggelaten - beperkt tot mijn eerste € 20.000 aan orders",
    "summaryTitle": "Jouw Pakket Overzicht",
    "croBridgeBody": "Gebaseerd op je situatie heb ik de beste combinatie voorgeselecteerd om te beginnen. Je kunt alles hieronder nog aanpassen, maar de meeste gebruikers vinden deze setup ideaal.",
    "croBridgeBodyPersonalized": "Gebaseerd op je feedback heb ik de beste combinatie voorgeselecteerd om te beginnen. Je kunt alles hieronder nog aanpassen, maar de meeste gebruikers vinden deze setup ideaal.",
    "croBridgeBodyGeneric": "Hier is de populairste combinatie om direct te starten. Deze setup bevat alles wat je nodig hebt voor een professionele online aanwezigheid.",
    "step1Title": "Bouw Je Pakket",
    "step2Title": "Jouw Domeinnaam",
    "step3Title": "Review & Lanceren"
  },
  "pricing": {
    "plan": "Plan",
    "features": "Functies",
    "price": "Prijs",
    "includes_tax": "*BTW vrijstelling geldt onder Nederlandse KOR",
    "mostPopular": "Meest Populair",
    "breakdownTitle": "Kostenspecificatie",
    "breakdownSubtitle": "Kristalheldere kosten, nul verrassingen",
    "summary": {
      "oneTimeServices": "Eenmalige diensten",
      "monthlyBilledPlans": "Maandelijks gefactureerde abonnementen",
      "yearlyBilledPlans": "Jaarlijks gefactureerde abonnementen",
      "vat": "BTW",
      "totalDueToday": "Totaal vandaag verschuldigd"
    },
    "upcoming": {
      "switchHint": "Wil je minder facturen? Schakel hieronder over naar Jaarlijks en ik bundel alles in één jaarlijkse betaling.",
      "afterToday": {
        "title": "Na Vandaag – Je Toekomstige Betalingen",
        "subtitle": "Wat gebeurt er nadat je het 'Totaal Vandaag Verschuldigd' hebt betaald."
      },
      "pill": {
        "monthly": {
          "note": "Volgende betaling op {date} • maandelijks gefactureerd voor 12 maanden. Eindigt op {endDate}",
          "aria": "Maandelijkse betalingen voor de komende 12 maanden"
        },
        "yearly": {
          "zero": {
            "note": "Ontspan — niets verschuldigd tot {date}.",
            "aria": "Geen betalingen tijdens de huidige jaarlijkse periode"
          },
          "note": "Na 12 maanden, verlenging op {date}.",
          "aria": "Verlengingsbedragen jaarlijks gefactureerd",
          "planBilledYearly": "Abonnement jaarlijks gefactureerd."
        },
        "renewal": {
          "monthly": {
            "note": "Na 12 maanden begint de verlenging: maandelijks gefactureerd.",
            "aria": "Verlengingsbedragen na het eerste jaar",
            "yearlyDomainRenewal": " Plus jaarlijkse domeinverlenging."
          }
        }
      },
      "label": {
        "current": "Komende 12 maanden",
        "renewal": "Verlenging"
      }
    }
  },
  "billing": {
    "monthly": "Maandelijks",
    "yearly": "Jaarlijks",
    "oneTime": "Eenmalig",
    "shortLabels": {
      "monthly": "/ mnd",
      "yearly": "/ jr",
      "year": "/ jaar"
    }
  },
  "plans": {
    "billingLabels": {
      "monthly": "per maand",
      "yearly": "per jaar",
      "oneTime": "eenmalig"
    },
    "webHosting_total": {
      "displayName": "Complete Website Pakket",
      "rationale": "Alles-in-één startpakket om je website live te krijgen - 5 pagina's en 1200 woorden met hosting, setup en email",
      "features": [
        "Webhosting (5GB SSD)",
        "Zakelijke email",
        "Voorgeïnstalleerd CMS met basis thema",
        "3-5 pagina's",
        "1200 woorden",
        "1x onboarding gesprek (20 min)",
        "1 revisie"
      ]
    },
    "webHosting_pro": {
      "displayName": "Complete Website Pakket Uitgebreid",
      "rationale": "Voor wanneer je meer ruimte en prioriteits-ondersteuning nodig hebt",
      "features": ["Alles van Complete pakket", "20GB SSD hosting", "Prioriteits-ondersteuning (email + chat)"]
    },
    "domain_managed": {
      "displayName": "Domein Beheer Service",
      "rationale": "Ik registreer en beheer je domein - geen technische gedoe, helemaal beveiligd",
      "features": ["1x .nl/.com domein registratie", "DNS & email setup voor je gedaan"]
    },
    "techConcierge_free": {
      "displayName": "Tech Concierge: Standaard",
      "rationale": "Essentieel onderhoud en snelle fixes om je site soepel te houden.",
      "features": [
        "Nachtelijke backups & off-site opslag",
        "Wekelijkse beveiliging & gezondheidsscans",
        "20-min maandelijkse snelle aanpassingen",
        "Toegang tot kennisbank"
      ]
    },
    "techConcierge_extra_5h": {
      "displayName": "Tech Concierge: Pakket (5u)",
      "rationale": "Extra toegewijde tijd voor custom aanpassingen en functies. Eenmalig verbruiken of in meerdere stappen.",
      "features": [
        "Totaal 5u toegewijde hands-on ondersteuning",
        "Prioriteits-ticket wachtrij",
        "Ik doe snelle aanpassingen zodat jij het niet hoeft"
      ]
    },
    "techConcierge_5h": {
      "displayName": "Dev Concierge: Dev Sprint (5u Pakket)",
      "rationale": "Iets speciaals laten bouwen? Dit 5-uur pakket geeft je custom ontwikkeling zonder maandelijkse verplichtingen.",
      "features": [
        "5u toegewijde dev tijd (eenmalig gebruik)",
        "Use cases: API integraties, thema aanpassingen",
        "2x 1-op-1 dev gesprekken (scope + review)",
        "Code overdracht met documentatie",
        "Geen doorlopende verplichtingen",
        "5-dagen levering gegarandeerd"
      ]
    },
    "growthCall_monthly": {
      "displayName": "Maandelijkse Growth Strategy Call",
      "rationale": "Blijf voorop met data-driven inzichten en expert begeleiding. Dit uitgebreide pakket biedt uitgebreide groei-tracking met persoonlijke strategie sessies.",
      "features": [
        "Custom analytics dashboard (GA4 + Clarity + Meta + Hotjar)",
        "Traffic & conversie inzichten met uitvoerbare aanbevelingen",
        "SEO + content gap analyse met concurrent inzichten",
        "CRO kansen alerts en A/B test suggesties",
        "Maandelijks strategie gesprek met groei specialist",
        "Email & PDF rapport met video walkthrough elke 30 dagen"
      ]
    },
    "humanContent_business": {
      "displayName": "Authority Content Accelerator",
      "rationale": "Vestig jezelf in jouw markt als een autoriteit door strategische content die engagement drijft en je positioneert als branche thought leader.",
      "features": [
        "4 lange artikelen (2.500+ woorden elk)",
        "Thought leadership positionering strategie",
        "SEO optimalisatie met keyword targeting",
        "Social media content kalender (16 posts)",
        "Email nieuwsbrief templates (4 per maand)",
        "Content prestatie analytics rapport"
      ]
    },
    "seo_booster": {
      "displayName": "SEO Opportunity Amplifier",
      "rationale": "Laat jouw SEO potentieel onderzoeken met een diepgaande analyse en strategische optimalisatie. Perfect voor wanneer de website klaar is om verder te groeien",
      "features": [
        "Uitgebreide site structuur audit & optimalisatie plan",
        "Interne linking strategie met 50+ link kansen",
        "5 content clusters met onderwerp mapping & keyword onderzoek",
        "Zoekintentie optimalisatie voor 20+ key pagina's",
        "Technische SEO fixes & pagina snelheid optimalisatie",
        "Concurrent gap analyse & content strategie",
        "90-dagen SEO roadmap met maandelijkse mijlpalen"
      ]
    },
    "cro_booster": {
      "displayName": "CRO Conversie Accelerator",
      "rationale": "Transformeer bezoekers naar kopers met data-driven conversie optimalisatie. Een wetenschappelijke aanpak om je website's prestaties te maximaliseren.",
      "features": [
        "Complete conversie funnel audit & heatmap analyse",
        "Gebruikersgedrag analyse met sessie opnames",
        "UX/UI optimalisatie voor 3 high-impact pagina's",
        "A/B test setup voor koppen, CTA's & pagina layouts",
        "Landing page optimalisatie met mobiele responsiviteit",
        "Conversie tracking & doel setup in analytics",
        "60-dagen optimalisatie roadmap met test kalender",
        "Maandelijks prestatie review gesprek"
      ]
    },
    "content_strategy": {
      "displayName": "Content Strategy Intensive",
      "rationale": "Laat een content fundament bouwen voor een consistente groei. Een strategische content aanpak om die prospects om te zetten in klanten.",
      "features": [
        "Uitgebreide content audit & concurrent analyse",
        "Content pilaren & boodschap framework ontwikkeling",
        "Redactionele kalender voor 6 maanden met onderwerp clusters",
        "SEO content strategie met keyword mapping",
        "Merk stem gids & content stijl documentatie",
        "Content distributie strategie over alle kanalen",
        "Prestatie meetkader & KPI's",
        "2 strategie sessies + maandelijkse check-ins voor 3 maanden"
      ]
    },
    "branding_mini": {
      "displayName": "Mini Brand Refresh",
      "rationale": "Een strategische visuele refresh die je merk moderniseert zonder vanaf nul te beginnen. Perfect voor gevestigde bedrijven die een eigentijdse update nodig hebben.",
      "features": [
        "Logo verfijning met 2 variaties (kleur/mono)",
        "Kleurenpalet optimalisatie (5 merkkleuren + tinten)",
        "Typografie systeem met primaire & secundaire lettertypes",
        "3 herontworpen desktop pagina mockups",
        "Merkrichtlijnen samenvatting (PDF)",
        "2 revisie rondes inbegrepen",
        "Social media logo variaties (4 formaten)"
      ]
    },
    "branding_full": {
      "displayName": "Complete Brand Evolution",
      "rationale": "Transformeer je volledige visuele identiteit met een uitgebreid merksysteem. Alles nodig voor consistente, professionele merkpresentie.",
      "features": [
        "Alles van Mini pakket",
        "3 logo variaties (full color, enkele kleur, pictogram)",
        "Uitgebreid kleur, typografie & spatiëring systeem",
        "8 merkelement suggesties (patronen, texturen, pictogrammen)",
        "Complete stijlgids (PDF + Figma bronbestanden)",
        "6 pagina mockups (3 desktop + 3 mobiel)",
        "Visitekaartje & briefhoofd ontwerp",
        "Social media merk kit (20+ templates)",
        "3 rondes feedback en verfijning",
        "Merk toepassing richtlijnen document"
      ]
    },
    "branding_premium": {
      "displayName": "Signature Brand Experience",
      "rationale": "De ultieme merk transformatie ervaring. Strategische positionering ontmoet premium ontwerp executie voor merken klaar om hun markt te leiden.",
      "features": [
        "Alles van Complete pakket",
        "Strategische merk positionering workshop (2 sessies)",
        "Merk verhaal, persoonlijkheid & stem ontwikkeling",
        "Markt differentiatie analyse & concurrentie audit",
        "Custom merk fotografie art direction gids",
        "10 pagina mockups (5 desktop + 5 mobiel)",
        "Presentatie template suite (PowerPoint + Keynote)",
        "Geavanceerd social media merk systeem (50+ templates)",
        "Merk implementatie roadmap & training sessie",
        "Prioriteits-ondersteuning & onbeperkte tweaks voor 30 dagen",
        "Express levering: 10 werkdagen"
      ]
    },
    "brand_audit": {
      "displayName": "Brand Identity Health Check",
      "rationale": "Ontdek hoe je merk presteert en waar je verbeteringen moet focussen. Perfecte startpunt voor grote merk investeringen.",
      "features": [
        "Uitgebreide merk audit over alle touchpoints",
        "Concurrerend visueel analyse & markt positionering review",
        "Merk consistentie evaluatie (website, social, print)",
        "Klant perceptie analyse & feedback verzameling",
        "Visuele identiteit sterkte/zwakte beoordeling",
        "Gedetailleerd verbeteringsaanbevelingen rapport",
        "60-minuten strategie gesprek om bevindingen te bespreken",
        "30-dagen actieplan met geprioriteerde verbeteringen"
      ]
    }
  },
  "planSelection": {
    "group": {
      "buildLaunch": {
        "title": "Bouwen & Lanceren",
        "subtitle": "Hosting, CMS, SSL, pagina's en email - alles-in-één fundament voor je website.",
        "tooltip": "Alles wat je nodig hebt om snel en veilig online te komen."
      },
      "techConcierge": {
        "title": "Tech Concierge",
        "subtitle": "Doorlopende expert hulp en ontwikkeling bursts - op jouw voorwaarden.",
        "tooltip": "Gebruik ons dev team wanneer en hoe je ze nodig hebt."
      },
      "growthOptimize": {
        "title": "Groei & Content Strategie",
        "subtitle": "Traffic, leads, content en CRM - upgrade je zichtbaarheid en funnels.",
        "tooltip": "Alles-in pakketten om te schalen wat al werkt."
      },
      "visualIdentity": {
        "title": "Visuele Identiteit & Merk Evolutie",
        "subtitle": "Van een lichte refresh tot een complete rebranding - upgrade hoe je bedrijf eruitziet, voelt en verbindt.",
        "tooltip": "Kies één branding track om je identiteit aan te scherpen, visueel vertrouwen te vergroten en op te vallen met doelgericht ontwerp."
      }
    }
  },
  "components": {
    "contactForm": {
      "title": "Heb je een Vraag of Hulp Nodig?",
      "namePlaceholder": "Jouw Naam",
      "emailPlaceholder": "Jouw Email",
      "subjectDefault": "Selecteer Onderwerp",
      "subjectGeneral": "Algemeen",
      "subjectSupport": "Ondersteuning",
      "subjectCollaboration": "Samenwerking",
      "messagePlaceholder": "Jouw Bericht",
      "submit": "Verstuur Bericht",
      "success": "Bericht succesvol verzonden!"
    },
    "header": {
      "getStarted": "Begin Nu",
      "language": "Taal",
      "openMenu": "Menu openen",
      "closeMenu": "Menu sluiten",
      "mobileMenu": "Mobiel menu",
      "menuLabel": "Menu"
    },
    "checkout": {
      "orderSummary": "Bestelling Overzicht"
    }
  },
  "testimonials": {
    "items": [
      {
        "quote": "Na 8 maanden vechten met WordPress en 3 ontwerpers die verdwenen, had ik binnen 5 dagen mijn website online met Siteoplossing. Mijn online verkopen gingen van €0 naar €12.000 in de eerste maand.",
        "author": "Sarah W., E-commerce Eigenaar",
        "logo": null,
        "context": "Van 8 maanden frustratie naar 5 dagen succes"
      },
      {
        "quote": "Ik wilde niet leren programmeren, hosting uitzoeken of plugins debuggen. Ik wilde mijn bedrijf runnen. Dat is precies wat ik nu kan doen dankzij deze service.",
        "author": "Tom B., Consultant",
        "logo": null,
        "context": "Van technische stress naar bedrijfsfocus"
      },
      {
        "quote": "Drie mislukte pogingen met verschillende bureaus kostten me €5000+ en 6 maanden. Siteoplossing leverde in een week wat anderen niet konden in een half jaar.",
        "author": "Anna K., Marketing Bureau",
        "logo": null,
        "context": "Van bureau failures naar betrouwbare resultaten"
      }
    ],
    "items[0]": {},
    "items[1]": {},
    "items[2]": {}
  },
  "chat": {
    "offlineMessage": "Live chat is momenteel offline.",
    "businessHours": "Kantooruren: Ma–Vr, 9:00–17:00"
  },
  "hero": {
    "title": "Plan of Lanceer Vandaag Je Droomwebsite",
    "optionBlueprintTitle": "Blueprint 100",
    "optionBlueprintDesc": "Beantwoord een snelle vragenlijst en ontvang een custom site plan plus expert hosting advies.",
    "optionTotalTitle": "Totaal Pakket",
    "optionTotalDesc": "Van ontwerp, ontwikkeling tot onderhoud van je site, stressvrije service.",
    "ctaBlueprint": "Start Mijn Gratis Blueprint",
    "ctaTotal": "Ontdek het Totaal Pakket"
  },
  "heroTotal": {
    "title": "Je Website Jaagt Klanten Weg Voordat Ze Kunnen Kopen",
    "subtitle": "Elke wegklik is een gemiste verkoop die naar je concurrent gaat.",
    "pain1": "Je website oogt als hobbyproject terwijl je serieus onderneemt.",
    "pain2": "Klanten twijfelen aan je professionaliteit en kiezen de concurrent.",
    "pain3": "Geen website? Dan ben je al helemaal onzichtbaar.",
    "supporting": "Je product is geweldig. Je website vertelt dat verhaal niet.",
    "midJourneyTitle": "Waarom Verdien Je Minder Dan Je Zou Moeten?",
    "midJourneyIntro": "Je hebt ervaring, kwaliteit, tevreden klanten. Nieuwe klanten zien alleen een website die niet overtuigt.",
    "deepenProblem1": "Het ergste: de perfecte klant kwam op je site maar vertrouwde je niet genoeg.",
    "deepenProblem2": "Ondertussen groeit je concurrentie terwijl jij vastzit."
  },
  "footer": {
    "site": {
      "tagline": "Compleet, betrouwbaar en simpel sinds 2015"
    },
    "company": {
      "title": "Bedrijf",
      "links": {
        "about": "Over",
        "contact": "Contact",
        "clientLogin": "Klant Login",
        "pricing": "Prijzen"
      }
    },
    "legal": {
      "title": "Juridisch",
      "links": {
        "terms": "Algemene Voorwaarden",
        "privacy": "Privacy Policy",
        "cookie": "Cookie Policy",
        "sla": "Service Level Agreement",
        "aup": "Acceptabel Gebruik Policy"
      }
    }
  },
  "benefits": {
    "heading": "Dit Is Wat Een Professionele Website Je Oplevert",
    "urgencySubtext": "Waarom ondernemers kiezen voor een complete oplossing in plaats van nog langer zelf klooien",
    "items": {
      "support": {
        "title": "Persoonlijke Begeleiding Van A Tot Z",
        "amplifier": "Geen anonieme klantenservice. Geen doorverwijzingen. Ik begeleid je persoonlijk van eerste gesprek tot lancering. En blijf beschikbaar voor vragen en aanpassingen."
      },
      "system": {
        "title": "Website Die Altijd Werkt, Nooit Crasht",
        "amplifier": "Betrouwbare hosting, dagelijkse backups, beveiligingsupdates. Alles geregeld zodat jij je geen zorgen hoeft te maken over technische dingen."
      },
      "transparency": {
        "title": "Vaste Prijs, Geen Verrassingen",
        "amplifier": "Je weet precies wat je betaalt en wat je krijgt. Geen uurtarieven die oplopen. Geen extra kosten achteraf. Gewoon een eerlijke, vaste prijs."
      },
      "focus": {
        "title": "Meer Tijd Voor Je Echte Werk",
        "amplifier": "Terwijl ik je website bouw, kun jij doen waar je goed in bent: klanten helpen en je bedrijf laten groeien."
      }
    }
  },
  "reassure": {
    "heading": "Je bent in goede handen - hier is waarom:",
    "guarantee": "Van kickoff tot lancering - je site, klaar binnen weken",
    "support": "1-op-1 ondersteuning voor elke klant",
    "cancel": "Heldere prijzen. Één jaar, nul verrassingen",
    "spotsLeft": "Nog maar {remaining} van {total} plekken over deze maand!",
    "cta": "Start Mijn Website Vandaag - Slechts €30/maand",
    "ctaSub": "Handel snel - beperkte plekken"
  },
  "exit": {
    "title": "Wacht! Voordat Je Gaat…",
    "subtitle": "Krijg 10% korting op je eerste maand als je nu inschrijft",
    "cta": "Claim Mijn Korting"
  },
  "journey": {
    "steps": [
      {
        "title": "Aanmelden",
        "desc": "Vul een snel formulier in - ik regel de rest"
      },
      {
        "title": "Discovery Interview",
        "desc": "Een 1-op-1 videogesprek om je behoeften te begrijpen"
      },
      {
        "title": "Initieel & Pagina Ontwerp",
        "desc": "Ik lever een werkend ontwerp met 5 kernpagina's"
      },
      {
        "title": "Feedback & Revisie",
        "desc": "Jij reviewt - ik verfijn"
      },
      {
        "title": "Definitieve Levering & Setup",
        "desc": "Email, admin overdracht, en 1 uur/maand gratis ondersteuning"
      }
    ],
    "steps[0]": {},
    "steps[1]": {},
    "steps[2]": {},
    "steps[3]": {},
    "steps[4]": {}
  },
  "social": {
    "testimonials": [
      {
        "quote": "Het hele proces was turnkey en stressvrij. Ik hou van de resultaten!",
        "author": "Sarah W."
      },
      {
        "quote": "Ik hoefde geen enkele regel code aan te raken.",
        "author": "Tom B."
      }
    ],
    "testimonials[0]": {},
    "testimonials[1]": {}
  },
  "legalOverview": {
    "cards": [
      {
        "title": "Algemene Voorwaarden",
        "description": "Je go-to voorwaarden voor het gebruik van mijn services.",
        "link": "/legal/terms-and-conditions"
      },
      {
        "title": "Privacy Policy",
        "description": "Hoe ik je data bescherm en gebruik.",
        "link": "/legal/privacy-policy"
      },
      {
        "title": "Cookie Policy",
        "description": "Leer over mijn cookie gebruik.",
        "link": "/legal/cookie-policy"
      },
      {
        "title": "Service Level Agreement",
        "description": "Mijn commitment aan uptime en ondersteuning.",
        "link": "/legal/sla"
      },
      {
        "title": "Acceptabel Gebruik Policy",
        "description": "Regels en richtlijnen voor het juiste gebruik van mijn services.",
        "link": "/legal/aup"
      }
    ],
    "cards[0]": {},
    "cards[1]": {},
    "cards[2]": {},
    "cards[3]": {},
    "cards[4]": {}
  },
  "problemAgitate": {
    "heading": "Herken Je Deze Bedrijf-Dodende Website Problemen?",
    "paragraph1": "Je kiest een platform. Selecteert een thema. Begint te bouwen.\n\nDan slaat de realiteit toe: eindeloze tweaks, technische blokkades, en nog steeds geen lanceerdatum in zicht.\n\nIntussen pakken je concurrenten klanten online af.",
    "bullet1": "Maanden werk zonder resultaten: Je hebt tijd besteed die je nooit terugkrijgt aan een \"bijna klaar\" website die nooit live ging",
    "bullet2": "Concurrenten maken verkopen terwijl jij nog bouwt: Elke dag offline = gemiste klanten die naar anderen gaan",
    "bullet3": "Technische stress in plaats van ondernemerschap: Jouw tijd gaat naar website issues in plaats van bedrijfsgroei",
    "transition": "Snelle realiteitscheck: Hoeveel omzet verlies je elke week zonder professionele website?"
  },
  "agitationTimeline": {
    "heading": "De Harde Cijfers: Dit Kost Een Slechte Website Je Echt",
    "subtitle": "Onderzoek toont aan wat een slechte eerste indruk je bedrijf kost:",
    "stats": {
      "research": {
        "percentage": "82%",
        "description": "doet online onderzoek voor een aankoop",
        "impact": "Zonder professionele website ben je onzichtbaar terwijl concurrenten jouw markt overnemen"
      },
      "credibility": {
        "percentage": "75%",
        "description": "verlaat je site als die er onprofessioneel uitziet",
        "impact": "3 op de 4 bezoekers gaan direct weg als je site er niet betrouwbaar uitziet."
      },
      "impression": {
        "time": "0,05",
        "description": "seconden om de eerste indruk te maken",
        "visual": "KLIK → OORDEEL → WEG",
        "impact": "Sneller dan je kunt knipperen hebben ze al besloten. En meestal niet in jouw voordeel."
      }
    },
    "realityCheck": {
      "title": "Deze Cijfers Zeggen Genoeg",
      "description": "Het is pijnlijk om te realiseren, maar deze statistieken laten duidelijk zien wat er gebeurt. Elke dag zonder professionele website betekent klanten die naar anderen gaan."
    }
  },
  "solutionBridge": {
    "hookQuestion": "Herken je deze frustratie?",
    "painAcknowledgment": "Ik zie het bij veel ondernemers. Je bent goed in wat je doet, maar je website laat je zakken. Dat knaagt, want je weet dat je meer klanten zou kunnen helpen.",
    "heading": "Er Is Een Betere Manier",
    "empathy": "Het probleem is niet jouw ondernemerschap. Het probleem is dat website bouwen een vak apart is. Net zoals jij specialist bent in jouw vakgebied.",
    "transformationQuestion": "Wat Als Je Website Wel Klanten Zou Aantrekken?",
    "systemDescription": "Stel je voor: bezoekers landen op je site en denken meteen 'dit is precies wat ik zoek'. Geen twijfel, geen aarzeling.",
    "solution1": "Professionele uitstraling die meteen vertrouwen wekt",
    "solution2": "Verhaal dat duidelijk maakt waarom jij de beste keuze bent",
    "solution3": "Website die klanten overtuigt in plaats van wegjaagt",
    "solution4": "Meer tijd voor je bedrijf in plaats van website gedoe",
    "wayForward": "Je hoeft geen web designer te worden. Je hebt gewoon iemand nodig die begrijpt wat ondernemers nodig hebben.",
    "missingPiece": "Hier is wat je tot nu toe miste..."
  },
  "socialProofEnhanced": {
    "heading": "Van Website Frustratie naar Online Succes",
    "subtitle": "Echte transformatieverhalen van ondernemers net als jij",
    "stories": [
      {
        "problem": "Maanden verspild aan verschillende web designers en tools. Steeds weer nieuwe uitleg, nieuwe vertragingen, nieuwe rekeningen.",
        "solution": "Eindelijk iemand die begrijpt wat ondernemers nodig hebben. Heldere communicatie, vaste deadlines, en een website die daadwerkelijk verkoopt.",
        "author": "Pascal, Catering Van Alex",
        "result": "Professionele website gelanceerd in 10 dagen • Eerste verkopen binnen 48 uur • €20.000 extra inkomsten eerste jaar"
      },
      {
        "problem": "Website online houden met snelheid, monitoren van de kwaliteit en geen dedicated hulp",
        "solution": "Veel heb ik zelf aan de website gedaan. Alleen de website was soms traag, en soms zat ik vast met technische punten of wou ik met iemand brainstormen over de marketing. Nu heb ik al mijn websites bij Yvo staan en wanneer er iets is word ik meteen geholpen.",
        "author": "Wouter van Aalst, Bamboogym",
        "result": "Nul technische betrokkenheid vereist • meer tijd voor klantenwerk"
      }
    ],
    "problemTitle": "Probleem",
    "logoCaption": "Enkele van mijn klanten die voor jou kwamen",
    "stats": {
      "websitesHelped": "Websites geholpen",
      "averageLaunchTimeNumber": "2 weken",
      "averageLaunchTime": "Gemiddelde lanceertijd",
      "clientSatisfaction": "Klanttevredenheid"
    }
  },
  "finalCTA": {
    "heading": "Start Je Website Deze Week",
    "trustSignal1": "8 Slimme Vragen: Instant Gepersonaliseerd Plan",
    "trustSignal2": "Custom Pakket Selectie: Perfecte Fit voor Jouw Bedrijf",
    "urgencyMessage": "Nog {remaining} plekken beschikbaar voor deze maand"
  },
  "scarcity": {
    "spotsRemaining": "Nog maar {spots} van {total} plekken over deze maand",
    "explanation": "Ik werk persoonlijk met elke klant. Daarom accepteren we maximaal 20 nieuwe projecten per maand."
  },
  "riskReversal": {
    "heading": "Mijn Kwaliteit Commitments aan Jou",
    "subtitle": "Hier is waar je op kunt rekenen",
    "guarantee": {
      "title": "Lancering Garantie",
      "description": "Van kickoff tot lancering - jouw site klaar binnen weken"
    },
    "launch": {
      "title": "Klantervaring Gefocust",
      "description": "1-op-1 ondersteuning voor elke klant"
    },
    "support": {
      "title": "Transparante Prijzen",
      "description": "Heldere prijzen. Vooraf afgesproken, nul verrassingen"
    }
  },
  "customerJourney": {
    "heading": "Moeite met zelf een website bouwen?",
    "summaryPoint1Title": "Jij Praat, Ik Luister",
    "summaryPoint1Desc": "We trappen af met de Blueprint 100 - een slim, begeleid formulier dat je visie vastlegt. Daarna duiken we dieper in een echt gesprek om alles op jou af te stemmen.",
    "summaryPoint2Title": "Jij Ziet, Ik Vorm",
    "summaryPoint2Desc": "Je ontvangt een mooi, custom ontwerp - en we herzien het samen totdat het je past als een handschoen.",
    "summaryPoint3Title": "We Lanceren, Ik Heb Je Rug",
    "summaryPoint3Desc": "Van setup tot ondersteuning, ik blijf bij je. Geniet van maandelijkse aanpassingen, snelle fixes en totale gemoedsrust.",
    "steps": [
      {
        "title": "Aanmelden",
        "desc": "Vul het snelle lead formulier in met je naam en email."
      },
      {
        "title": "Discovery Interview",
        "desc": "Ontmoet via een 1-op-1 videogesprek om je doelen te begrijpen."
      },
      {
        "title": "Initieel 5-Pagina Ontwerp",
        "desc": "Ik lever een volledig ontwerp binnen 1 week voor feedback."
      },
      {
        "title": "Feedback & Revisie Meeting",
        "desc": "Ik verfijn de site op basis van je opmerkingen en voorkeuren."
      },
      {
        "title": "Definitieve Levering & Setup",
        "desc": "Je krijgt je live site, custom domein en email setup."
      },
      {
        "title": "Doorlopende Ondersteuning",
        "desc": "Geniet van 1 uur/maand gratis ondersteuning en aanpassingen via ticket."
      }
    ],
    "form": {
      "title": "Begin Met Je Totaal Pakket",
      "submit": "Begin Nu",
      "microcopy": "Geen creditcard vereist"
    },
    "fallback": {
      "title": "Nog aan het twijfelen?",
      "text": "Niet zeker of mijn Totaal Pakket geschikt voor je is? Plan een gratis consult om meer te leren!",
      "button": "Plan een Consult"
    },
    "steps[0]": {},
    "steps[1]": {},
    "steps[2]": {},
    "steps[3]": {},
    "steps[4]": {},
    "steps[5]": {}
  },
  "deep": {
    "heading": "Nog Vragen? Laten We Dieper Gaan",
    "faqTitle": "Veelgestelde Vragen",
    "faq": [
      {
        "question": "Wat is de exacte tijdlijn van start tot lancering?",
        "answer": "Meeste websites zijn klaar in 1-2 weken, afhankelijk van hoe snel je de Blueprint100 vragenlijst voltooit en revisies goedkeurt."
      },
      {
        "question": "Heb ik technische vaardigheden nodig?",
        "answer": "Nope. Ik zorg ervoor dat alles geregeld wordt - van setup tot lancering. Er zijn ook pakketten ontworpen om je website verder te laten groeien. Van Search Engine Optimization, User Experience Optimization en Conversion Rate Optimization. Pakketten ontworpen om nog meer uit je website te halen."
      },
      {
        "question": "Wat als ik nog niet weet wat ik wil?",
        "answer": "Geen zorgen - ik kan je helpen met verschillende opties. We kunnen een 1-op-1 discovery gesprek plannen waar ik je help je doelen te verduidelijken en aanbeveel welke plannen het beste werken. Liever eerst zelf verkennen? Je kunt ook de snelle 8 vragen 'Quick Planner' voltooien of je kunt ook de uitgebreidere Blueprint 100 gebruiken: een stap-voor-stap vragenlijst die je ideeën omzet in een custom website plan."
      },
      {
        "question": "Is het domein en email inbegrepen?",
        "answer": "Het domein is niet standaard inbegrepen - het is een standalone add-on voor €15 per jaar, inclusief gratis SSL en beheerde DNS. Liever je domein elders houden? Geen probleem - ik geef stap-voor-stap instructies zodat je alles zelf kunt configureren. Email setup is hoe dan ook inbegrepen."
      },
      {
        "question": "Welke ondersteuning krijg ik na lancering?",
        "answer": "Na lancering zorg ik ervoor dat je website 24/7 online blijft, je server veilig is, en alle services - zoals email - soepel blijven draaien. Bovendien krijg je elke maand 20 minuten gratis updates. Grotere wijzigingen of nieuwe functies nodig? Ik help graag met project-gebaseerde prijzen - of je kunt kiezen uit een reeks vaste-prijs pakketten met duidelijke routines zoals CRO optimalisatie, SEO audits, of website analytics setups die echte groei drijven."
      },
      {
        "question": "Kan ik de website later zelf updaten?",
        "answer": "Ja! Ik geef admin toegang en een korte gids, zodat je op elk moment eenvoudige aanpassingen kunt maken."
      },
      {
        "question": "Wat als ik later meer pagina's of functies wil toevoegen?",
        "answer": "Ik groei met je mee. Extra werk kan worden geboekt naar behoefte, en ik quoteer altijd voordat ik begin."
      },
      {
        "question": "Kan ik een terugbetaling aanvragen als ik van gedachten verander?",
        "answer": "Ik bied geen terugbetalingen zodra het werk begint, maar je kunt op elk moment annuleren voordat het project begint."
      },
      {
        "question": "Is dit beter dan een DIY builder zoals Wix of Squarespace?",
        "answer": "Ja - met mijn Totaal Pakket doe ik al het werk, stem alles af op je bedrijf, en bied doorlopende ondersteuning."
      }
    ],
    "compareTitle": "Wat is het Verschil?",
    "compareSubtitle": "Vergelijk mijn Totaal Pakket met typische DIY opties",
    "compare": {
      "total": "Totaal Pakket",
      "basic": "DIY Builders",
      "features": [
        {
          "name": "Done-for-You Setup",
          "total": "Inbegrepen - ik regel alles",
          "basic": "Je doet het zelf"
        },
        {
          "name": "Discovery Gesprek",
          "total": "1-op-1 videogesprek om je doelen te begrijpen",
          "basic": "Geen gepersonaliseerde begeleiding"
        },
        {
          "name": "Custom Website Design",
          "total": "Afgestemd op je merk & doelgroep",
          "basic": "Kies een generiek template"
        },
        {
          "name": "Content Schrijf Ondersteuning",
          "total": "Ik begeleid of schrijf tot 1200 woorden",
          "basic": "Je bent op jezelf aangewezen"
        },
        {
          "name": "Revisies Inbegrepen",
          "total": "Één ronde wijzigingen na feedback",
          "basic": "Handmatige aanpassingen met beperkte tools"
        },
        {
          "name": "Domein & Email Setup",
          "total": "Inbegrepen & volledig geconfigureerd",
          "basic": "Koop & koppel afzonderlijk"
        },
        {
          "name": "1-op-1 Maandelijkse Ondersteuning",
          "total": "1 uur/maand inbegrepen via email of ticket",
          "basic": "Betaal extra of geen ondersteuning"
        },
        {
          "name": "Admin Toegang & Overdracht",
          "total": "Volledige controle met training indien nodig",
          "basic": "Je beheert alles vanaf het begin"
        },
        {
          "name": "Focus op Je Bedrijf",
          "total": "Ik regel de tech, jij blijft gefocust",
          "basic": "Afgeleid leren tools, plugins & fixes"
        },
        {
          "name": "Tijdsinvestering",
          "total": "1 uur (ik doe alles)",
          "basic": "40+ uur leren & bouwen"
        },
        {
          "name": "Risico",
          "total": "Vaste prijs garantie",
          "basic": "Onbekende kosten & tijd"
        },
        {
          "name": "Resultaat",
          "total": "Professional vanaf dag 1",
          "basic": "Amateur uitstraling tijdens leerproces"
        }
      ]
    }
  },
  "totalForm": {
    "heading": {
      "step1": "Laten we beginnen met je contactgegevens",
      "step2": "Waarmee heb je hulp nodig?",
      "step3": "Wil je nu een afspraak inplannen?"
    },
    "step0": {
      "title": "Laten we iets geweldigs bouwen voor je bedrijf",
      "desc": "Beantwoord 3 snelle vragen en ik stel een website plan samen specifiek voor jou",
      "note": "Duurt minder dan 1 minuut",
      "cta": "Start Mijn Website Vandaag"
    },
    "needsOptions": ["Lanceer een nieuwe website", "Verbeter mijn huidige", "Iets anders"],
    "placeholders": {
      "name": "Jouw Naam",
      "email": "Jouw Email"
    },
    "step3": {
      "desc": "Je kunt direct een tijd kiezen voor een gratis consult, of later beslissen.",
      "now": "Ja, ik plan nu mijn consult",
      "later": "Nee, ik besluit liever later"
    },
    "step4": {
      "title": "Plan Je Gratis Consult",
      "desc": "Kies een tijd die het beste uitkomt. Mijn team staat klaar om je te helpen beginnen."
    },
    "gdpr": {
      "title": "Wil je een herinnering ontvangen?",
      "desc": "Je hebt nog geen consult ingepland. Wil je dat ik je een follow-up email stuur ter herinnering?",
      "agree": "Ja, stuur me een herinnering",
      "decline": "Nee bedankt"
    },
    "goodbye": {
      "title": "Geen probleem!",
      "desc": "Je koos ervoor geen follow-up emails te ontvangen. Dat respecteer ik.",
      "cta": "Als je van gedachten verandert, kun je altijd contact opnemen via mijn contactpagina."
    },
    "progress": "Stap {step} van 3",
    "privacy": "Ik gebruik deze info om contact met je op te nemen. Nooit spam.",
    "thanks": "Bedankt! Ik neem binnenkort contact op.",
    "followup": "Je ontvangt binnen 1 werkdag een email met volgende stappen.",
    "next": "Volgende"
  },
  "smartLeadForm": {
    "next": "Volgende",
    "progress": "Stap {step} van {total}",
    "step2": {
      "title": "Wat is je belangrijkste doel?",
      "options": {
        "getClients": "Meer klanten aantrekken",
        "showcase": "Mijn werk laten zien",
        "sellProducts": "Producten online verkopen",
        "needHelp": "Ik heb hulp nodig met mijn website"
      }
    },
    "start": {
      "title": "Doe De 2-Minuten Quiz",
      "desc": "Gewoon 5 snelle vragen beantwoorden en je krijgt een plan dat past bij jouw bedrijf, jouw tempo en jouw doelen.",
      "cta": "Geef Me Mijn Lanceerplan - 2 Minuten",
      "note": "Geen jargon. Geen druk. Gewoon duidelijkheid."
    },
    "situation": {
      "title": "Wat is jouw huidige situatie?",
      "options": {
        "starting": "Ik begin vanaf nul — heb website + alles nodig",
        "haveWebsite": "Heb bestaande website — wil meer klanten & groei",
        "needMaintenance": "Heb bestaande website — wil onderhoud & fixes"
      }
    },
    "primaryGoal": {
      "title": "Wat is jouw hoofddoel op dit moment?",
      "options": {
        "buildWebsite": "Mijn website live krijgen en starten",
        "getClients": "Meer leads & klanten online binnenhalen",
        "fixMaintain": "Huidige website verbeteren & onderhouden"
      }
    },
    "involvement": {
      "title": "Hoe betrokken wil je zijn?",
      "options": {
        "handsOff": "Doe alles voor mij",
        "collab": "Ik wil samenwerken — ik geef input",
        "diyHelp": "Begeleid me erdoorheen — ik wil leren hoe het werkt"
      }
    },
    "timeline": {
      "title": "Wat is jouw tijdlijn?",
      "options": {
        "now": "Nu starten — ik ben klaar om te beginnen",
        "soon": "Binnen 30 dagen beginnen",
        "exploring": "Ik ben mijn opties aan het verkennen"
      }
    },
    "investment": {
      "title": "Wat kun je investeren voor groei?",
      "options": {
        "starter": "€30-200/maand + €500 eenmalig — Basis website & essentials",
        "professional": "€200-500/maand + €1500 eenmalig — Groei & optimalisatie",
        "premium": "€500+/maand + €3000+ eenmalig — Premium alles-inclusief"
      }
    },
    "planReady": {
      "title": "Jouw Persoonlijke Plan Is Klaar",
      "description": "Gebaseerd op jouw antwoorden heb ik de best passende pakketten geselecteerd om je te helpen lanceren met duidelijkheid en snelheid.",
      "recommendedTitle": "Aanbevolen voor jou:",
      "moreProducts": "+ {count} meer pakketten",
      "cta": "Laat Me Mijn Aanbevolen Plannen Zien",
      "ctaLabel": "Verken mijn plan opties",
      "note": "Afgestemd op jouw doelen. Volledig transparante prijzen."
    },
    "contact": {
      "title": "Waar moet ik jouw plan samenvatting naartoe sturen?",
      "namePlaceholder": "Jouw naam",
      "emailPlaceholder": "Jouw email adres",
      "cta": "Email Me Het Plan"
    },
    "gdpr": {
      "title": "Wil je tips & tools om online te groeien?",
      "desc": "Af en toe emails met groei tips, geen spam. Je kunt altijd uitschrijven.",
      "accept": "Ja, stuur me tips",
      "decline": "Nee bedankt"
    }
  },
  "terms": {
    "title": "Algemene Voorwaarden",
    "subtitle": "Heldere en begrijpelijke voorwaarden voor het gebruik van de diensten",
    "intro": "Elke keer als je een overeenkomst aangaat met Siteoplossing gelden mijn standaard algemene voorwaarden. Benieuwd wat al die juridische termen betekenen? Ik heb ze voor je vertaald naar heldere en begrijpelijke taal.",
    "full_version_link": "volledige versie",
    "agreement_title": "Jouw Overeenkomst met Siteoplossing",
    "agreement_text": "Een overeenkomst ontstaat wanneer je je registreert en een bestelling bij ons plaatst, met mijn algemene voorwaarden als leidraad. Afhankelijk van wat je bestelt kan de looptijd variëren: een jaar voor domeinnamen (met automatische verlenging) en SSL certificaten (zonder automatische verlenging), en maandelijks tot jaarlijks voor alle andere services.",
    "external_conditions_title": "Externe Voorwaarden en Je Toestemming",
    "external_conditions_text": "Soms heb ik andere bedrijven nodig om services aan jou te leveren. Indien van toepassing ga je via ons akkoord met hun aanvullende voorwaarden.",
    "account_info_title": "Je Account Informatie",
    "account_info_text": "Je beheert je services via een controlpaneel toegankelijk via je account, waarvoor ik accurate informatie nodig heb. Meld wijzigingen direct.",
    "maintenance_backups_title": "Onderhoud en Backups",
    "maintenance_backups_text": "Om services optimaal te houden is soms onderhoud nodig, en ik maak regelmatig backups die op jouw verzoek beschikbaar zijn.",
    "upgrades_domains_title": "Upgrades en Domein Registratie",
    "upgrades_domains_text": "Upgrades zijn altijd mogelijk; downgrades vereisen het beëindigen van je huidige overeenkomst en het starten van een nieuwe. Ik regel de papierwinkel voor je domeinnaam en andere registraties.",
    "payments_price_title": "Betalingen en Prijsaanpassingen",
    "payments_price_text": "Je betaalt vooraf voor terugkerende kosten en achteraf voor eenmalige kosten. Ik kan prijzen aanpassen met voorafgaande kennisgeving.",
    "use_of_services_title": "Jouw Gebruik van Services",
    "use_of_services_text": "Gebruik de services verantwoordelijk, zonder schade aan mijn netwerk of anderen. Overtredingen kunnen leiden tot service opschorting.",
    "rights_data_title": "Je Rechten en Data Verwerkings Overeenkomst",
    "rights_data_text": "Je behoudt rechten op je data. Als consument kun je een service binnen 14 dagen annuleren, behalve voor domein en SSL registraties. Een data verwerkings overeenkomst is vereist voor het verwerken van andermans data.",
    "termination_title": "Beëindiging van Services",
    "termination_text": "Je kunt annuleren met één maand opzegtermijn. Zorg dat je je data veiligstelt voor beëindiging, en weet dat je altijd welkom bent om terug te keren."
  },
  "privacy": {
    "title": "Privacybeleid",
    "subtitle": "Hoe jouw persoonlijke gegevens worden beschermd en behandeld",
    "intro_text": "Bij Siteoplossing verzamel ik alleen de minimale data die nodig is om mijn services te leveren en je ervaring met mijn productpagina's te verbeteren. Je data wordt zorgvuldig behandeld om je privacy te beschermen.",
    "our_promises_title": "Mijn Vier Beloftes aan Jou",
    "our_promises_list": [
      "Ik bescherm je persoonlijke data alsof het mijn eigen is.",
      "Je persoonlijke data wordt uitsluitend gebruikt voor de doeleinden beschreven in deze verklaring.",
      "Ik bewaar je data niet langer dan strikt noodzakelijk.",
      "Ik deel nooit je persoonlijke data met derden zonder geldige reden."
    ],
    "personal_data_title": "Welke Persoonlijke Data Verwerkt Siteoplossing?",
    "personal_data_intro": "Om de overeenkomst die je met ons aangaat na te komen heb ik bepaalde informatie van je nodig:",
    "personal_data_list": [
      "Naam en Adres: Voor communicatie, facturering en misschien zelfs een koffie wanneer je langskomt.",
      "Bedrijfsgegevens: Als je mijn zakelijke services gebruikt houd ik deze gescheiden van je persoonlijke informatie.",
      "E-mailadres: Voor belangrijke meldingen over je bestelling of account, en updates via nieuwsbrieven, met de optie om je af te melden.",
      "Telefoonnummer: Voor noodgevallen, feedback, twee-factor authenticatie of monitoring van je VPS.",
      "Logingegevens en Klantnummer: Om je account veilig te houden en je sneller te kunnen helpen.",
      "IP Adres: Om account toegang bij te houden en te helpen beschermen tegen ongeautoriseerde toegang.",
      "Betalingsinformatie: Om je bestellingen en betalingen te verwerken, inclusief via betalingsservices zoals PayPal."
    ],
    "other_data_title": "Andere Data Verwerkt door Siteoplossing",
    "other_data_intro": "Niet alle data is essentieel voor het leveren van mijn services. Soms verzamel ik extra informatie op basis van je toestemming of een gerechtvaardigd belang:",
    "other_data_list": [
      "Werk-Gerelateerde Persoonlijke Data: Voor sollicitaties. Als je niet wordt aangenomen wordt je informatie binnen 12 maanden verwijderd.",
      "Cookies: Om je gebruikerservaring te analyseren en mijn website en advertenties te personaliseren. Je kunt je toestemming op elk moment intrekken.",
      "Server Logs: Automatisch verzamelde data zoals je IP adres en browser versie, gebruikt om mijn systemen te beveiligen en fouten op te lossen.",
      "Crash Data: Data verzameld om crashes in mijn app te analyseren en voorkomen, opgeslagen voor maximaal 3 maanden."
    ],
    "purpose_title": "Doel van Data Verwerking",
    "purpose_text": "Siteoplossing verwerkt je persoonlijke informatie voor heldere doeleinden: toegang verlenen tot mijn services, functionaliteit van mijn website onderhouden, je overeenkomst nakomen, in contact blijven, klachten behandelen, beveiliging en fraude preventie verzekeren, en reageren op sollicitaties.",
    "purpose_consent_text": "Met je toestemming kan ik ook je informatie gebruiken om mijn website en services te analyseren en verbeteren, content en advertenties te personaliseren, en promoties te delen die bij je interesses passen.",
    "security_title": "Beveiliging",
    "security_text": "Ik ben toegewijd aan sterke beveiligingsmaatregelen om misbruik en ongeautoriseerde toegang tot je data te voorkomen, inclusief het gebruik van SSL certificaten voor veilige data overdracht.",
    "third_parties_title": "Je Privacy en Derden",
    "third_parties_text": "Je data wordt alleen gedeeld in specifieke situaties, zoals het leveren van mijn services, voldoen aan wettelijke verplichtingen, of registreren van domeinnamen. Met je toestemming kan ik data delen om mijn services te verbeteren, mensen van bots te onderscheiden met tools zoals reCAPTCHA, of feedback verzamelen via onderzoeksbureaus.",
    "automated_decisions_title": "Geautomatiseerde Beslissingen",
    "automated_decisions_text": "Geautomatiseerde beslissingen, zoals het versturen van waarschuwingen voor gemiste betalingen, worden gemaakt op basis van je data. Aanhoudende non-betaling kan resulteren in geblokkeerde of zelfs beëindigde services.",
    "cookies_title": "Cookies",
    "cookies_text": "Cookies kunnen persoonlijke data bevatten; bekijk mijn cookie policy voor meer details.",
    "third_party_websites_title": "Derde Partij Websites",
    "third_party_websites_text": "Mijn privacy en cookie policy geldt niet voor derde partij websites waar ik naar link. Bekijk hun policies voordat je persoonlijke data deelt.",
    "privacy_rights_title": "Je Privacy Rechten",
    "privacy_rights_text": "Als gebruiker heb je het recht om je data in te zien, te corrigeren of te verwijderen, of bezwaar te maken tegen de verwerking. Neem contact op via je controlpaneel of neem contact op met mijn support team voor hulp of om een klacht in te dienen.",
    "contact_title": "Contact Informatie",
    "contact_info": {
      "company": "Siteoplossing",
      "address": "Parkweg 100, 6511 BK Nijmegen",
      "email": "contact [at] siteoplossing.nl",
      "linkedin": "https://www.linkedin.com/company/siteoplossing",
      "kvk": "57753938",
      "vat": "NL004847619B65"
    }
  },
  "cookie": {
    "title": "Cookiebeleid",
    "subtitle": "Hoe ik cookies gebruik om je ervaring te verbeteren",
    "intro": "Cookies zijn kleine tekstbestanden opgeslagen op je apparaat wanneer je mijn site bezoekt. Ze stellen je in staat om automatisch in te loggen en te onthouden wat je in je winkelwagentje hebt dankzij opgeslagen informatie. Cookies helpen me ook je gebruik van de site te analyseren en bepalen welke services je aantrekkelijk vindt. Er zijn verschillende soorten cookies: functionele voor basis werking, analytische voor gebruiksinzichten, en marketing cookies voor gepersonaliseerde advertenties. Je kunt altijd je cookie voorkeuren aanpassen via de privacy instellingen pagina.",
    "functionalCookiesTitle": "Functionele cookies",
    "functionalCookiesText": "Ik gebruik functionele cookies om je voorkeuren op te slaan en producten in je winkelwagen te houden.",
    "functionalCookiesTable": {
      "headers": ["Cookie Naam", "Max Bewaring", "Geplaatst Door", "Doel"],
      "rows": [
        [
          "WHMCSInstanceID",
          "Einde van sessie",
          "WHMCS / client.siteoplossing.nl",
          "Slaat een uniek sessie ID op om status tussen pagina loads te behouden."
        ],
        [
          "WHMCSUser",
          "365 dagen",
          "WHMCS / client.siteoplossing.nl",
          "Gebruikt voor 'onthoud mij' functionaliteit zodat je niet herhaaldelijk hoeft in te loggen."
        ]
      ]
    },
    "analyticsCookiesTitle": "Analytische cookies",
    "analyticsCookiesText": "Ik gebruik analytische cookies om te begrijpen hoe je mijn site gebruikt en deze te verbeteren.",
    "analyticsCookiesTable": {
      "headers": ["Cookie Naam", "Max Bewaring", "Geplaatst Door", "Doel"],
      "rows": [
        ["g_state", "30-07-2024 12:00:06", "siteoplossing.nl", "Gebruikt voor het analyseren van websitegebruik."]
      ]
    },
    "marketingCookiesTitle": "Marketing cookies (prestatie, affiliate, en tracking)",
    "marketingCookiesText": "Prestatie cookies meten advertentie succes, affiliate cookies koppelen verkopen aan partners, en tracking cookies volgen product interesse.",
    "marketingCookiesTable": {
      "headers": ["Cookie Naam", "Max Bewaring", "Geplaatst Door", "Doel"],
      "rows": [
        [
          "WHMCSAffiliateID",
          "90 dagen",
          "WHMCS / client.siteoplossing.nl",
          "Slaat het affiliate ID op voor klant verwijzingen binnen 90 dagen."
        ],
        [
          "WHMCSLinkID",
          "Persistent",
          "WHMCS / client.siteoplossing.nl",
          "Volgt de oorspronkelijke link gebruikt door de bezoeker voor conversie tracking."
        ]
      ]
    },
    "deletingCookiesTitle": "Cookies verwijderen en uitschakelen",
    "deletingCookiesText": "Cookies worden automatisch verwijderd na hun bewaarperiode. Je kunt ook handmatig cookies verwijderen of blokkeren via je browser instellingen.",
    "lastUpdated": "Deze pagina werd laatst bijgewerkt op 06/02/2024."
  },
  "sla": {
    "title": "Service Level Agreement",
    "subtitle": "Mijn toezegging voor servicebeschikbaarheid en jouw rechten",
    "intro": "Siteoplossing streeft ernaar je services altijd beschikbaar te houden. Er kunnen echter momenten zijn dat dit niet mogelijk is. In deze sectie verduidelijk ik je rechten als een service onbeschikbaar wordt. Geïnteresseerd in de juridische details? Je kunt de ",
    "full_version_link": "volledige juridische versie hier vinden",
    "webhosting_title": "Web Hosting Services",
    "webhosting_text_1": "Siteoplossing biedt een 99,95% maandelijkse uptime garantie voor web hosting. Dit betekent dat je website niet meer dan ongeveer 22 minuten per maand offline zal zijn. Als je website langer onbeschikbaar was heb je recht op compensatie.",
    "webhosting_text_2": "Je kunt compensatie aanvragen via het controlpaneel, en deze wordt gecrediteerd op je volgende factuur.",
    "webhosting_text_3": "Je kunt de hoogte van compensatie berekenen met de volgende formule:",
    "webhosting_formula": "(Maandelijkse Web Hosting Kosten / Aantal Minuten in de Maand) × (Downtime Minuten - 22) × 100",
    "webhosting_max_compensation": "De maximale compensatie is de maandelijkse kosten van je web hosting service.",
    "other_services_title": "Andere Services",
    "other_services_text_1": "Ik bied geen expliciete uptime garantie voor mijn andere services.",
    "other_services_text_2": "Je komt mogelijk in aanmerking voor compensatie als je service meer dan twee uur onbeschikbaar was. Om compensatie te claimen kun je contact met me opnemen via het controlpaneel.",
    "other_services_formula": "(Maandelijkse Service Kosten / Totaal Aantal Minuten in de Maand) × (Downtime Minuten - 120)"
  },
  "aup": {
    "title": "Acceptabel Gebruik Beleid",
    "subtitle": "Richtlijnen voor verantwoord gebruik van de diensten",
    "intro": "Met Siteoplossing's TotaalPakket wil ik je een complete, zorgeloze ervaring bieden. Om alles soepel te laten verlopen heb ik een paar heldere afspraken gemaakt. Liever de volledige juridische tekst lezen? Die vind je hier: ",
    "full_version_link": "juridische versie",
    "scope_title": "Wat zit er in het TotaalPakket?",
    "scope_list": [
      "3 GB web hosting ruimte.",
      "50 GB data verkeer per maand.",
      "Onbeperkt aantal e-mailadressen.",
      "Een basis website van maximaal 5 pagina's, samen met jou ontwikkeld.",
      "Basis SEO optimalisatie (paginatitels, meta tags, interne links)."
    ],
    "maintenance_title": "Updates en Onderhoud",
    "maintenance_text_1": "Ik zorg ervoor dat je website veilig en up-to-date blijft met regelmatige beveiliging en software updates.",
    "maintenance_text_2": "Bij gepland onderhoud geef ik je minimaal 48 uur van tevoren bescheid.",
    "maintenance_text_3": "Urgente beveiligingsupdates kunnen zonder voorafgaande kennisgeving worden uitgevoerd.",
    "support_title": "Ondersteuning",
    "support_text_1": "Hulp nodig? Ik ben beschikbaar op weekdagen van 9:00 tot 17:00 via email, telefoon, tickets of chat.",
    "support_text_2": "Ik streef ernaar binnen 24 uur te reageren. Let op: dit is een inhoudelijke reactie, geen garantie van onmiddellijke oplossing.",
    "support_text_3": "Ik bied tot 1 uur gratis ondersteuning per maand. Eventueel extra werk buiten het pakket wordt altijd vooraf besproken.",
    "other_title": "Andere Afspraken",
    "other_text_1": "Voor zaken zoals backups, service beëindiging of aansprakelijkheid gelden mijn algemene voorwaarden.",
    "other_text_2": "Door gebruik te maken van het TotaalPakket ga je akkoord met deze gebruiksvoorwaarden."
  },
  "dashboard": {
    "overview": "Overzicht",
    "users": "Gebruikers",
    "sales": "Verkoop",
    "revenue": "Omzet",
    "orders": "Bestellingen",
    "trends": "Trends",
    "chartPlaceholder": "Grafiek komt hier"
  },
  "ui": {
    "title": "Creëer Je Perfecte Website—Stap voor Stap",
    "next": "Volgende",
    "back": "Terug",
    "summary_section": "Controleer Je Blueprint",
    "yes": "✔️ Ja",
    "no": "❌ Nee",
    "download_pdf": "Download PDF",
    "send_email": "Stuur naar mijn email",
    "email_subject": "Jouw Site Blueprint – {score}/100",
    "email_body": "Hier is jouw gepersonaliseerde site blueprint!",
    "inputs": {
      "pick_an_option": "Kies een optie",
      "selected_option": "Geselecteerde Optie",
      "fontexample": "De snelle bruine vos springt over de luie hond",
      "pagination": {
        "previous": "Vorige",
        "next": "Volgende"
      },
      "chooseColorPalette": "Kies een kleurenpalet"
    }
  },
  "schema": {
    "projectFoundation": {
      "title": "Project Fundament",
      "questions": {
        "foundationDomain": {
          "label": "Jouw Doeldomein",
          "placeholder": "bijv. mijnbedrijf.com",
          "help": "Waar zullen klanten je online vinden?",
          "summaryLabel": "Domein:"
        },
        "foundationGoals": {
          "label": "Primaire Website Doelen",
          "help": "Selecteer doelen die aansluiten bij je topprioriteiten.",
          "summaryLabel": "Doelen:",
          "options": {
            "leadCapture": "Leads Vastleggen",
            "ecom": "Verkopen Stimuleren",
            "portfolio": "Werk Showcasen",
            "blog": "Autoriteit Opbouwen",
            "other": "Anders",
            "notSure": "Niet zeker"
          }
        },
        "foundationLaunchTimeline": {
          "label": "Lancering Timeline",
          "help": "Wanneer moet je live gaan om belangrijke kansen te grijpen?",
          "summaryLabel": "Timeline:",
          "options": {
            "immediate": "Binnen 2 weken",
            "month": "1 maand",
            "quarter": "2–3 maanden",
            "undecided": "Onbeslist"
          }
        },
        "foundationNeededPages": {
          "label": "Kern Web Functies",
          "help": "Welke pagina's of functionaliteiten moet je site bevatten?",
          "summaryLabel": "Functies:",
          "options": {
            "notSure": "Niet zeker hierover",
            "contactForm": "Contactformulier",
            "ecommerceCart": "E-commerce Winkelwagen",
            "blog": "Blog",
            "faqSection": "FAQ Sectie",
            "portfolioGallery": "Portfolio Galerij",
            "bookingSystem": "Boekingssysteem",
            "userLogin": "Gebruiker Inlog",
            "chatbotSupport": "Chatbot Ondersteuning",
            "newsletterSignup": "Nieuwsbrief Aanmelding",
            "eventsCalendar": "Evenementen Kalender",
            "multiLanguageSupport": "Meertalige Ondersteuning",
            "analyticsDashboard": "Analytics Dashboard"
          }
        }
      }
    },
    "storyCredibility": {
      "title": "Verhaal & Geloofwaardigheid",
      "questions": {
        "credibilityOneLiner": {
          "label": "Elevator Pitch",
          "placeholder": "In één zin, wat maakt jou uniek?",
          "help": "Creëer een beknopte verklaring die je unieke waarde benadrukt.",
          "summaryLabel": "Pitch:"
        },
        "credibilityMission": {
          "label": "Kern Missie & Pijn",
          "placeholder": "Beschrijf de grootste uitdaging die je oplost",
          "help": "Welke pijnpunten pak je aan voor je klanten?",
          "summaryLabel": "Missie/Pijn:"
        },
        "credibilityAssets": {
          "label": "Social Proof Assets",
          "help": "Upload testimonials, case studies of logo's die geloofwaardigheid opbouwen.",
          "summaryLabel": "Bewijs:"
        },
        "credibilityTrustSignals": {
          "label": "Vertrouwen-Bouwende Elementen",
          "help": "Welk soort social proof kun je nu bieden?",
          "summaryLabel": "Vertrouwen Signalen:",
          "options": {
            "dontHaveAny": "Heb er op dit moment geen",
            "testimonials": "Klant Testimonials",
            "certifications": "Certificeringen",
            "awards": "Awards",
            "press": "Pers Vermeldingen",
            "logos": "Klant Logo's"
          }
        },
        "credibilityToneGrid": {
          "label": "Merk Persoonlijkheid",
          "help": "Kies de stem die het meest resoneert met je doelgroep.",
          "summaryLabel": "Persoonlijkheid:",
          "options": {
            "professional": "Professioneel",
            "playful": "Speels",
            "luxury": "Luxe",
            "friendly": "Vriendelijk",
            "innovative": "Innovatief",
            "notSure": "Ik ben hier niet zeker van"
          }
        }
      }
    },
    "designBranding": {
      "title": "Ontwerp & Branding",
      "questions": {
        "brandingPrimaryColor": {
          "label": "Kenmerkende Kleur",
          "help": "Kies de kleur die het beste de essentie van je merk weergeeft.",
          "summaryLabel": "Kleur:"
        },
        "brandingPalette": {
          "label": "Ondersteunend Palet",
          "help": "Selecteer aanvullende kleuren voor consistentie.",
          "summaryLabel": "Palet:"
        },
        "brandingFont": {
          "label": "Typografie Stijl",
          "help": "Welk lettertype brengt het karakter van je merk over?",
          "summaryLabel": "Lettertype:"
        },
        "brandingStyles": {
          "label": "Ontwerpelementen",
          "help": "Welke ontwerp-esthetieken sluiten aan bij je identiteit?",
          "summaryLabel": "Stijlen:",
          "options": {
            "minimalist": "Minimalistisch",
            "illustrative": "Illustratief",
            "photography": "Fotografie-gedreven",
            "boldTypography": "Gedurfde Typografie",
            "darkMode": "Donkere Modus"
          }
        },
        "brandingLogoUpload": {
          "label": "Logo Bestand",
          "help": "Upload je logo bestand (PNG/SVG).",
          "summaryLabel": "Logo:"
        }
      }
    },
    "contentStructure": {
      "title": "Content & Structuur",
      "questions": {
        "contentCorePages": {
          "label": "Kernpagina's",
          "help": "Selecteer welke pagina's je wilt gebruiken",
          "summaryLabel": "Pagina's:",
          "options": {
            "home": "Home",
            "about": "Over",
            "services": "Services",
            "contact": "Contact",
            "blog": "Blog",
            "faq": "FAQ"
          }
        },
        "contentKeywords": {
          "label": "Doel Onderwerpen & Keywords",
          "placeholder": "Lijst tot 10 high-impact termen",
          "help": "Welke onderwerpen of keywords trekken je ideale klanten aan?",
          "summaryLabel": "Keywords:"
        },
        "contentWritingStyle": {
          "label": "Schrijfstijl Voorkeuren",
          "help": "Selecteer de formaten en structuren die het beste passen bij hoe je doelgroep leest.",
          "summaryLabel": "Stijl:",
          "options": {
            "concise": "Beknopt & To-the-Point",
            "narrative": "Verhaal-Gedreven Narratieven",
            "analytical": "Data-Heavy & Analytisch",
            "conversational": "Conversationeel & Vriendelijk",
            "visual": "Visueel Gestructureerd (lijsten, headers)",
            "seo": "SEO-Gefocust & Keyword-Rijk",
            "unsure": "Nog niet zeker"
          }
        },
        "contentBlogChoices": {
          "label": "Blog/Nieuws Formaat",
          "help": "Welke soorten blog of nieuws updates wil je publiceren?",
          "ariaLabel": "Selecteer de soorten blog of nieuws updates",
          "summaryLabel": "Geselecteerde Blog Formaten:",
          "options": {
            "articles": "Diepgaande Artikelen (how-to's, thought leadership)",
            "news": "Bedrijfsnieuws & Aankondigingen",
            "caseStudies": "Case Studies & Succesverhalen",
            "quickGuides": "Snelle Tips & Praktische Gidsen",
            "undecided": "Onbeslist (help me kiezen)"
          }
        }
      }
    },
    "integrationsMarketing": {
      "title": "Integraties & Marketing",
      "questions": {
        "marketingExistingTools": {
          "label": "Bestaande Marketing Tools",
          "help": "Welke tools gebruik je al?",
          "summaryLabel": "Tools:",
          "options": {
            "dontNeed": "Ik heb dit niet nodig",
            "mailchimp": "Mailchimp",
            "hubspot": "HubSpot",
            "ga": "Google Analytics",
            "zapier": "Zapier",
            "stripe": "Stripe",
            "none": "Geen"
          }
        },
        "marketingSocial": {
          "label": "Social Platforms",
          "help": "Op welke social platforms ga je promoten?",
          "summaryLabel": "Social:",
          "options": {
            "facebook": "Facebook",
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "twitter": "Twitter",
            "tiktok": "TikTok",
            "other": "Anders",
            "dontHave": "Ik heb dit niet"
          }
        },
        "marketingFunnel": {
          "label": "Klant Funnel Beschrijving",
          "placeholder": "Map de stappen van prospect naar koper",
          "help": "Beschrijf hoe je nu mensen in klanten omzet.",
          "summaryLabel": "Funnel:"
        },
        "marketingApiGrid": {
          "label": "API Integraties",
          "help": "Welke API integraties hebben prioriteit?",
          "summaryLabel": "Integraties:",
          "options": {
            "dontNeed": "Denk niet dat ik dit nodig heb",
            "crm": "CRM",
            "payment": "Payment Gateway",
            "analytics": "Analytics",
            "automation": "Marketing Automatisering",
            "custom": "Custom API"
          }
        },
        "marketingGrowthTactics": {
          "label": "Groei Strategieën",
          "help": "Welke tactieken wil je graag testen voor snelle groei?",
          "summaryLabel": "Tactieken:",
          "options": {
            "seo": "SEO",
            "ppc": "PPC Ads",
            "email": "Email Campagnes",
            "referral": "Referral Programma",
            "abTesting": "A/B Testing",
            "dontNeed": "Denk niet dat ik dit nodig heb"
          }
        }
      }
    }
  },
  "aboutPage": {
    "hero": {
      "title": "SiteOplossing: Premium Tools & Ondersteuning, Gebouwd voor Jou",
      "subtitle": "Één ontwikkelaar. Gepersonaliseerde service. Krachtige oplossingen.",
      "cta": "Laten We Praten"
    },
    "story": {
      "heading": "Wie Zit Er Achter Siteoplossing?",
      "description": "Ik ben een solo ontwikkelaar gepassioneerd door het creëren van tools en services die anderen versterken. Met focus op kwaliteit en zorg is Siteoplossing mijn manier om premium ondersteuning en digitaal vakmanschap aan te bieden.",
      "cards": {
        "experience": {
          "title": "Jaren Ervaring",
          "body": "10+ in software & web ontwikkeling"
        },
        "clients": {
          "title": "Tevreden Klanten",
          "body": "Meer dan 100+ ondersteunde bedrijven"
        },
        "focus": {
          "title": "Focus Gebieden",
          "body": "Hosting, SaaS tools, fullstack apps"
        }
      }
    }
  },
  "progressBar": {
    "aria": "Stap {current} van {total} – {percent}% voltooid"
  },
  "triggeredRecommendations": {
    "hereIsWhy": "Hier is waarom deze setup op jou is afgestemd",
    "budgetBasedTitle": "Gebaseerd op Je Budget",
    "goalBasedTitle": "Gebaseerd op Je Doelen",
    "budgetExplanation": {
      "starter": "Deze pakketten passen perfect binnen je €30-200/maand budget:",
      "professional": "Maximale waarde binnen je professionele budgetbereik:",
      "premium": "Je premium budget geeft toegang tot mijn meest uitgebreide oplossingen:"
    },
    "goalExplanation": {
      "getClients": "Voor meer klanten heb ik groeifocused services toegevoegd:",
      "haveWebsite": "Voor website optimalisatie zijn deze services aanbevolen:",
      "handsOff": "Voor hands-off management regel ik alles voor je:",
      "default": "Gebaseerd op je behoeften helpen deze services je slagen:"
    },
    "croBridgeTitle": "Ik heb je antwoorden geanalyseerd en je gematched met een ideale setup - voorgeselecteerd voor snelheid en impact. Jij hebt controle: pas gerust aan, maar deze combo is voor de meeste klanten perfect.",
    "build": {
      "standardPackage": "Het Complete Website Pakket is jouw startpunt - snel, veilig en volledig beheerd. Heeft alles voor een professionele lancering: standaard template, 5 pagina's/1200 woorden en 30 producten.",
      "ecommercePro": "Voor E-commerce voegt Complete Website Pakket+ 20 GB hosting en prioriteits-ondersteuning toe voor hoger verkeer en transacties.",
      "domainManaged": "Met het Domein Beheer Service regel ik alles rondom jouw domeinnaam: registratie, DNS setup, verlengingen en SSL - jij kunt focussen op groei."
    },
    "tech": {
      "conciergeFree": "Tech Concierge houdt je site veilig en up-to-date met backups, beveiligingsscans en snelle fixes - plus gratis maandelijkse website wijzigingen",
      "contentSupport1h": "Voor custom content, blog ondersteuning en andere kleine aanpassingen - Het Tech Concierge pakket geeft 5 uur tijd als een strippenkaart",
      "contactOrAssets5h": "Voor custom Contact setup of asset integratie - mijn 5-uur Dev Sprint levert hands-on ondersteuning voor API's, themes en developer overdrachten"
    },
    "content": {
      "blogSeoAi": "Voor regelmatige SEO blog posts - AI Content (5 Posts) genereert geoptimaliseerde artikelen met jouw keywords.",
      "proCopywriting5": "Voor professioneel geschreven pagina's - Copywriting (5 Pagina's) geeft merk-stem content met SEO en revisies.",
      "keywordResearch": "Voor meer organisch verkeer - Keyword Onderzoek analyseert high-intent keywords en geeft on-page optimalisatie begeleiding.",
      "monthlyGrowthCall": "Voor een sterke fundering en strategische roadmap - Maandelijks Growth Strategy Call geeft expert begeleiding en custom marketing plan.",
      "crmIntegration": "Voor CRM integratie - mijn CRM Workflow Setup automatiseert je lead funnel met custom formulier-workflows."
    },
    "optimize": {
      "professionalUx": "Voor een professioneel/minimalistisch gevoel - Usability Testing ontdekt gebruiker pijnpunten met sessie opnames en heatmaps.",
      "logoRefresh": "Met je geüploade logo - Merk Visuele Refresh moderniseert je identiteit met bijgewerkt logo, palet & mockups.",
      "multilingual7plus": "Voor vertalingen van 7+ pagina's of custom social content - Meertalige Vertaling zorgt voor native-reviewed, cultureel accurate copy."
    },
    "direct": {
      "growthAnalytics": "Monthly Growth Strategy Call geeft inzicht in wat werkt. Data-driven beslissingen voor snellere groei.",
      "seoOpportunity": "Ontdek onbenutte SEO-kansen die je website helpen groeien—van analyse tot concrete optimalisatie.",
      "brandRefresh": "Het Mini Brand Refresh pakket zorgt voor een professionele en onvergetelijke eerste indruk—unieke branding gebaseerd op jouw bedrijf."
    },
    "budget": {
      "starter": "Je €50-150/maand budget past perfect bij starter pakketten - alles voor professionele lancering zonder overbodige kosten.",
      "professional": "Met jouw €150-400/maand groei budget kan ik je uitrusten met geavanceerde tools voor schaal en optimalisatie.",
      "premium": "Je €500+/maand premium budget geeft toegang tot mijn volledige suite - van content tot conversie optimalisatie."
    },
    "situation": {
      "noWebsite": "Zonder bestaande website heb ik een complete startsetup geselecteerd met hosting, domein en alles om online te komen.",
      "outdatedWebsite": "Je website heeft een upgrade nodig - ik heb pakketten gekozen die conversies verbeteren en meer leads genereren."
    },
    "goal": {
      "moreLeads": "Voor meer klanten heb ik SEO, content en analytics tools toegevoegd om je online bereik te vergroten.",
      "maintenance": "Voor betrouwbare ondersteuning zorgen tech concierge diensten dat je website altijd up-to-date en veilig blijft."
    },
    "involvement": {
      "handsOff": "Ik heb content en ondersteuningsdiensten toegevoegd zodat alles voor jou geregeld wordt."
    },
    "urgency": {
      "immediate": "Voor je urgente timeline heb ik extra ondersteuning toegevoegd om alles snel en soepel te laten verlopen."
    },
    "focus": {
      "ecommerce": "Voor e-commerce succes zijn conversie optimalisatie en analytics essentieel - daarom toegevoegd aan je pakket.",
      "b2bService": "Als B2B service provider zijn autoriteit content en professionele branding cruciaal voor vertrouwen met klanten."
    },
    "fallback": {
      "description": "Niet zeker over deze selectie? Doe mijn 2-minuten quiz voor een gepersonaliseerde aanbeveling.",
      "buttonText": "Krijg Mijn Op Maat Plan"
    }
  },
  "accountCreation": {
    "title": "Laten We Beginnen Met Je Account",
    "subtitle": "Stel je account in om verder te gaan.",
    "alreadyRegistered": "Een account met dit email bestaat al. Log in of gebruik een ander email adres."
  },
  "form": {
    "email": "Email adres",
    "loading": "Account controleren...",
    "continue": "Verder",
    "validation": {
      "required": "Dit veld is verplicht.",
      "invalidEmail": "Voer een geldig email adres in."
    },
    "genericError": "Er ging iets mis. Probeer opnieuw."
  },
  "journeyTimeline": {
    "title": "Van Frustratie Tot Trots Op Je Website in 2 Weken",
    "description": "Terwijl anderen maanden bezig zijn met klooien, heb jij binnen 2 weken een website waar je trots op bent",
    "steps": [
      {
        "title": "Kennismaking",
        "desc": "Je vult de Blueprint 100 in (een vragenlijst die je website-wensen in kaart brengt), dan bellen we kort. Zo snap ik meteen wat je nodig hebt.",
        "duration": "30 min",
        "emotionalBenefit": "Eindelijk iemand die snapt wat je nodig hebt"
      },
      {
        "title": "Ontwerp & Teksten",
        "desc": "Ik maak je website met teksten die overtuigen en een ontwerp dat vertrouwen wekt. Jij hoeft niks te doen.",
        "duration": "1 week",
        "emotionalBenefit": "Opluchting dat het eindelijk gebeurt"
      },
      {
        "title": "Jouw Feedback",
        "desc": "Je bekijkt alles, geeft feedback, en ik pas aan tot je 100% tevreden bent.",
        "duration": "2 dagen",
        "emotionalBenefit": "Gevoel van controle en betrokkenheid"
      },
      {
        "title": "Live Gaan",
        "desc": "Website online, domein gekoppeld, email ingesteld. Alles werkt, alles is geregeld.",
        "duration": "1 dag",
        "emotionalBenefit": "Trots dat je eindelijk een website hebt waar je achter staat"
      },
      {
        "title": "Doorlopende Ondersteuning",
        "desc": "Vragen? Aanpassingen? Ik blijf beschikbaar. Je bent niet alleen gelaten na de lancering.",
        "duration": "Altijd",
        "emotionalBenefit": "Zekerheid dat er altijd hulp is"
      }
    ]
  },
  "pricingSummary": {
    "title": "Pakket Overzicht",
    "clarifier": "Dit pakket omvat {months} maanden service. Je kunt kiezen om maandelijks of vooruitbetalen",
    "ctaButton": "Naar Checkout"
  },
  "contact": {
    "heading": "Neem Contact Op",
    "options": {
      "ticket": {
        "title": "Stuur een Mail",
        "description": "Expert hulp binnen 1 werkdag"
      },
      "consult": {
        "title": "Plan Consult",
        "description": "Snel een 1-op-1 afspraak maken"
      },
      "chat": {
        "title": "Live Chat",
        "online": "Ik ben nu online!",
        "offline": "Offline - kantooruren"
      }
    }
  },
  "thankYou": {
    "title": "Bedankt voor je Bestelling!",
    "subtitle": "Ik heb je bestelling ontvangen en ga meteen aan de slag.",
    "invoiceLabel": "Factuurnummer",
    "confirmationEmail": "Je vindt binnen een paar minuten een bevestigingsmail in je mailbox.",
    "teamContact": "Ik neem binnen 24 uur contact met je op om je project te bespreken.",
    "projectStart": "Ik begin zo snel mogelijk met het bouwen van je website.",
    "backToHome": "Terug naar Homepage",
    "contactUs": "Neem Contact Op"
  },
  "countries": {
    "NL": "Nederland",
    "BE": "België"
  }
}
